import TimeAgo from 'javascript-time-ago'
import { createAsync, query, useParams } from "@solidjs/router";
import { createMemo, createEffect, For, Show } from "solid-js";
import { CertificateState, padId, RIASRecordType } from "~/lib";

const { getByUser } = await import( "~/_server/dynamoDB" );
import "~/_assets/admin.css";

const certificatesQuery = query( async ( userId: number ) => {
	"use server";

	console.log( `Getting certifier ${RIASRecordType.CERTIFICATE} for user`, userId );

	return await getByUser( RIASRecordType.CERTIFICATE, userId, -1 );
}, "getCertifierCertificates" );


const subscriptionsQuery = query( async ( userId: number ) => {
	"use server";

	console.log( `Getting certifier ${RIASRecordType.SUBSCRIPTION} for user`, userId );

	return await getByUser( RIASRecordType.SUBSCRIPTION, userId, -1 );
}, "getCertifierSubscriptions" );



export const CertifierCertificates = () => {
	const { id } = useParams();
	const timeAgo = new TimeAgo( 'en-GB' );
	const certificates = createAsync( () => certificatesQuery( parseInt( id ?? "0" ) ) );

	createEffect( () => console.log( "Certifier certs", certificates() ) );

	return (
		<table id="certificates-table" class="table-fixed w-full border-collapse text-[13px]" aria-label="Certificates list">
			<thead>
				<tr>
					<th class="text-left w-23">Status</th>
					<th class="text-left w-32">Certificate</th>
					<th class="text-left">Project</th>
					<th class="text-right w-16">Plots</th>
					<th class="text-right w-22">Fee</th>
					<th class="text-right w-26">Issued</th>
				</tr>
			</thead>
			<tbody>
				<Show when={certificates()?.items?.length}>
					<For each={certificates().items}>{c => <CertificateRow c={c} timeAgo={timeAgo} />}</For>
				</Show>
			</tbody>
		</table>
	)
}


const CertificateRow = ( props: any ) => {

	const memoized = createMemo( () => {
		const isDraft = props.c.status === CertificateState.DRAFT;
		const isPaid = props.c.status === CertificateState.PAID;
		const isPublished = props.c.status === CertificateState.PUBLISHED || isPaid;
		const isStaged = !!props.c.meta.isStagedCertificate;
		const stageCount = ( props.c.meta?.stages?.length ?? 0 ) + 1;

		const amendCount = ( props.c.meta?.amendments?.length ?? 0 ) + 1;

		return {
			isDraft,
			isPaid,
			isPublished,
			isStaged,
			stageCount,
			amendCount,
		}
	} );

	return (
		<tr data-id="C0002956" class="certificate-row" tabindex="0" role="row" aria-selected="false">
			<td class="px-3 py-1.75 border-b border-border align-middle text-center">
				<span class={`cert-status ${props.c.status}`}>{props.c.status}</span>
			</td>
			<td class="px-3 py-1.75 border-b border-border align-middle">
				<div class="flex items-center gap-1.5">
					<span class="inline-flex items-center justify-center w-[18px] h-[18px] rounded-[4px] text-[9.5px] font-bold shrink-0 bg-blue-subtle text-blue-text" title="Domestic">D</span>
					<span class="font-mono text-[11.5px] text-text-2">C{padId( props.c.riasId )}</span>
				</div>
			</td>
			<td class="px-3 py-1.75 border-b border-border align-middle text-[13px] whitespace-nowrap overflow-hidden text-ellipsis">{props.c.name}</td>
			<td class="px-3 py-1.75 border-b border-border align-middle text-[13px] text-right">{props.c.meta.plots.length}</td>
			<td class="px-3 py-1.75 border-b border-border align-middle text-[13px] text-right">{props.c.meta.certificateFee}</td>
			<td class="px-3 py-1.75 border-b border-border align-middle text-[11px] text-text-3 text-right">{props.timeAgo.format( props.c.created * 1000 )}</td>
		</tr>
	)
}